import keycloakConfig from "./keycloakConfig";
import Keycloak from "keycloak-js";
import { setSessionCookies, removeSessionCookies } from "../../common/sessions/tokenHelper";
import { clearEnums } from "../../../utils/enums/enumActions";
import { setV2Access, clearV2Storage } from "../../../utils/v2Access";

const TOKEN_MIN_VALIDITY = 240;

let instance;
let keycloakInstance = new Keycloak(keycloakConfig);


class KeycloakManager {
    constructor() {
        if (instance) {
            throw new Error("New instance cannot be created.");
        }
        instance = this;
    }

    async login(accessToken, refreshToken, loginActions) {
        try {
            const initOptions = { onLoad: "check-sso", checkLoginIframe: false, useNonce: false, pkceMethod: "S256" };
            if (accessToken) initOptions.token = accessToken;
            if (refreshToken) initOptions.refreshToken = refreshToken;
            keycloakInstance
                .init(initOptions)
                .then((auth) => {
                    if (auth) {
                        setSessionCookies(keycloakInstance.token, keycloakInstance.refreshToken);
                        setV2Access(keycloakInstance.tokenParsed && keycloakInstance.tokenParsed['msys-www-v2'] === 'true');
                        loginActions.verifyAuth();
                    } else {
                        keycloakInstance.login();
                    }
                });
        } catch (e) {
            // init() could throw an error if a keycloak instance is already iniatialized
            // This happens at logout, an instance is already initialized and msys login page calls this function
            // In this case we redirect to sso login page
            keycloakInstance.login();
        }
    }
    async initiate(accessToken, refreshToken, callback) {
        try {
            keycloakInstance
                .init({ onLoad: "check-sso", checkLoginIframe: false, useNonce: false, pkceMethod: "S256", token: accessToken, refreshToken: refreshToken })
                .then((auth) => {
                    if (auth) {
                        setSessionCookies(keycloakInstance.token, keycloakInstance.refreshToken);
                        setV2Access(keycloakInstance.tokenParsed && keycloakInstance.tokenParsed['msys-www-v2'] === 'true');
                    }
                    callback();
                });
        } catch (e) {
            callback();
        }
    }

    async refreshTokens(accessToken, refreshToken) {
        keycloakInstance.token = accessToken;
        keycloakInstance.refreshToken = refreshToken;
        await keycloakInstance.updateToken(TOKEN_MIN_VALIDITY);
        return [keycloakInstance.token, keycloakInstance.refreshToken];
    }

    async logout(redirectURI=null) {
        clearEnums();
        removeSessionCookies();
        clearV2Storage();
        sessionStorage.removeItem("associatedClientIds");
        sessionStorage.removeItem("associatedClients");
        localStorage.removeItem("languageCode");
        localStorage.removeItem("roleAccess");
        localStorage.removeItem("roleId");

        if (!redirectURI)
            redirectURI = `${window.location.origin}/login`;
        return keycloakInstance.logout({redirectUri: redirectURI});
    }
}

const keycloakManager = Object.freeze(new KeycloakManager());
export default keycloakManager;



// WEBPACK FOOTER //
// ./src/components/login/sso/keycloakManager.js